import {
  MetacomConnectionStatus,
  MetacomState,
} from "@core/models/metacom.interface";
import { createSelector } from "@ngrx/store";

export const selectMetacomFeature = (state: { metacom: MetacomState }) =>
  state.metacom;

export const selectMetacomState = createSelector(
  selectMetacomFeature,
  (state) => state
);

export const selectMetacomDetails = createSelector(
  selectMetacomFeature,
  (state) => state.data
);

export const selectMetacomLoading = createSelector(
  selectMetacomFeature,
  (state) => state.isLoading
);

export const selectMetacomConnectionStatus = createSelector(
  selectMetacomFeature,
  (state) => {
    return {
      isLoading: state.isLoading,
      connected: state.connected,
      momentCreated: state.momentCreated,
    } as MetacomConnectionStatus;
  }
);
